import Vue from 'vue';
import VueMq from 'vue-mq';

Vue.use(VueMq, {
    breakpoints: {
        sm: 768, // tablet - mobile (768px - 0px)
        tsm: 1024, // larger tablets (smaller laptops) - tablet (1024px - 769px)
        md: 1250, // desktop - laptops (1250px - 1025px)
        lg: Infinity, // larger desktop - desktop (1251px +)
    },
    defaultBreakpoint: null,
});
